// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"435":"27338dd3","618":"8fb07622","902":"03a2cdda"}[chunkId] + ".chunk.js";
};